export const WHITE_BOARD_PREFERENCES_EVENT = "FBX_WHITE_BOARD_PREFERENCES_CHANGE";

export const DEFAULT_WHITE_BOARD_GRADE_COLORS = {
  "1": "#e15252",
  "2": "#e15252",
  "3": "#e15252",
  "4": "#f2c94c",
  "5": "#f2c94c",
  "6": "#f2c94c",
  "7": "#0f8a4b",
  "8": "#0f8a4b",
  "9": "#0f8a4b",
  "10": "#0f8a4b",
  A: "#0f8a4b",
  B: "#f2c94c",
  C: "#f2c94c",
  D: "#e15252",
  E: "#e15252",
  F: "#e15252",
};

export const WHITE_BOARD_NUMERIC_GRADE_KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
export const WHITE_BOARD_LETTER_GRADE_KEYS = ["A", "B", "C", "D", "E", "F"];
export const DEFAULT_WHITE_BOARD_POSITION_MARKER_COLOR = "#333333";

const normalizeHexColor = (value, fallback = "#d8dce3") => {
  const text = String(value || "").trim();
  return /^#[0-9a-fA-F]{6}$/.test(text) ? text : fallback;
};

export const normalizeWhiteBoardPositionMarkerColor = (value) => normalizeHexColor(
  value,
  DEFAULT_WHITE_BOARD_POSITION_MARKER_COLOR
);

export const normalizeWhiteBoardPreferences = (preferences = {}) => {
  const sourceColors = preferences?.gradeColors || preferences?.colors || {};
  const gradeColors = Object.keys(DEFAULT_WHITE_BOARD_GRADE_COLORS).reduce((colors, key) => {
    colors[key] = normalizeHexColor(sourceColors[key], DEFAULT_WHITE_BOARD_GRADE_COLORS[key]);
    return colors;
  }, {});

  return {
    gradeColors,
  };
};

export const getWhiteBoardGradeKey = (grade) => {
  const text = String(grade ?? "").trim();
  if (!text) return "";

  const upperText = text.toUpperCase();
  if (/^[A-F]$/.test(upperText)) return upperText;

  const numericMatch = text.match(/\d+/);
  if (!numericMatch) return "";

  const numericValue = Number.parseInt(numericMatch[0], 10);
  if (!Number.isFinite(numericValue) || numericValue < 1 || numericValue > 10) return "";
  return String(numericValue);
};

export const getReadableTextColor = (backgroundColor) => {
  const color = normalizeHexColor(backgroundColor);
  const r = Number.parseInt(color.slice(1, 3), 16);
  const g = Number.parseInt(color.slice(3, 5), 16);
  const b = Number.parseInt(color.slice(5, 7), 16);
  const luminance = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return luminance >= 150 ? "#111111" : "#ffffff";
};
